import { IconComponent } from 'models/icons';

/**
 * This file was auto-generated using svgr
 *
 * Source file: assets/icons/viewes.svg
 */
const IconViewes: IconComponent = ({
  size = 24,
  color = 'white',
  className,
  svgElementProps: props = {},
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    color={color}
    className={className}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.001 4.999H4a1 1 0 00-1 1V18a1 1 0 001 1H20a1 1 0 001-1V6a1 1 0 00-1-1zM4 3.999a2 2 0 00-2 2V18a2 2 0 002 2H20a2 2 0 002-2V6a2 2 0 00-2-2H4z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.999 4.999h-2v2h18.003V5h-2v1H6.998v-1H6v1h-1v-1z"
      fill="currentColor"
    />
    <path d="M15 13a3 3 0 11-6 0 3 3 0 016 0z" fill="currentColor" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 15a2 2 0 100-4 2 2 0 000 4zm0 1a3 3 0 100-6 3 3 0 000 6z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.001 13S16.993 9 12 9s-7.001 4-7.001 4S7.007 17 12 17s7.001-4 7.001-4zM6.174 13l.032.046c.232.327.59.767 1.085 1.207C8.274 15.126 9.796 16 12 16c2.204 0 3.726-.875 4.709-1.748A7.221 7.221 0 0017.826 13a7.221 7.221 0 00-1.117-1.253C15.726 10.876 14.204 10 12 10c-2.204 0-3.726.875-4.709 1.748A7.223 7.223 0 006.174 13zm11.935-.451v-.002.002zm0 .902v0zm-12.218.002z"
      fill="currentColor"
    />
  </svg>
);

export default IconViewes;
